import React from 'react';
import { Box, Typography } from '@material-ui/core';
import {
  BathIcon,
  BedIcon,
  StraightenIcon,
  UnitSizeIcon,
} from '../../../../../assets/icons';

export const CCP_UnitModelsTableHeaderData = (palette, styles) => [
  {
    id: 1,
    formFieldId: 1,
    minWidth: 230,
    headerName: 'Unit modal',
    field: 'propertyUnitModelName',
    isHiddenFilter: false,
    sortable: true,
    filterable: true,
    fieldType: 'text',
    renderCell: (item) => {
      return (
        <div style={{ paddingLeft: '6px' }}>
          {item?.row?.propertyUnitModelName}
        </div>
      );
    },
  },
  {
    id: 2,
    formFieldId: 2,
    minWidth: 230,
    headerName: 'Number of units',
    field: 'unitsNo',
    isHiddenFilter: false,
    sortable: true,
    filterable: true,
    fieldType: 'text',
    renderCell: (item) => {
      return (
        <div style={{ paddingLeft: '6px' }}>{item?.row?.unitsNo || 'N/A'}</div>
      );
    },
  },
  {
    id: 3,
    formFieldId: 3,
    minWidth: 230,
    headerName: 'Unit Type',
    field: 'unitTypeName',
    isHiddenFilter: true,
    sortable: true,
    filterable: true,
    fieldType: 'text',
    renderCell: (item) => {
      return (
        <div style={{ paddingLeft: '6px' }}>
          {item?.row?.unitTypeName || 'N/A'}
        </div>
      );
    },
  },
  {
    id: 4,
    formFieldId: 4,
    minWidth: 444,
    headerName: 'Unit details',
    field: 'area',
    isHiddenFilter: true,
    sortable: true,
    filterable: true,
    fieldType: 'text',

    renderCell: (item) => {
      return (
        <Box className={styles.containerDetailsUnit}>
          <Box className={styles.containerTypeDetails}>
            <UnitSizeIcon
              width='20'
              height='20'
              fill={palette.foreground.quinary}
            />
            <Typography>{item?.row?.area}</Typography>
          </Box>
          <Box className={styles.containerTypeDetails}>
            <BedIcon
              width={20}
              height={20}
              fill={palette.foreground.quinary}
            />
            <Typography>{item?.row?.bedroomNo}</Typography>
          </Box>
          <Box className={styles.containerTypeDetails}>
            <BathIcon
              width={20}
              height={20}
              fill={palette.foreground.quinary}
            />
            <Typography>{item?.row?.bathroomNo}</Typography>
          </Box>
          <Box className={styles.containerTypeDetails}>
            <StraightenIcon
              width={20}
              height={20}
              fill={palette.foreground.quinary}
            />
            <Typography>{item?.row?.maidsRoomNo}</Typography>
          </Box>
        </Box>
      );
    },
  },
  {
    id: 5,
    formFieldId: 5,
    minWidth: 444,
    headerName: 'Selling price range',
    field: 'sellingPriceFrom',
    fieldType: 'text',
    isHiddenFilter: true,
    sortable: true,
    filterable: true,
    renderCell: (item) => {
      return (
        <Box className={styles.containerFromTO}>
          <Typography className={styles.typePriceTitle}>ADE</Typography>
          <Typography className={styles.fromToTitle}>
            {`${item?.row?.sellingPriceFrom} - ${item?.row?.sellingPriceTo}`}
          </Typography>
        </Box>
      );
    },
  },
  {
    id: 6,
    formFieldId: 6,
    minWidth: 444,
    headerName: 'Rent price range',
    field: 'rentPerYearFrom',
    isHiddenFilter: true,
    sortable: true,
    filterable: true,
    fieldType: 'text',
    renderCell: (item) => {
      return (
        <Box className={styles.containerFromTO}>
          <Typography className={styles.typePriceTitle}>ADE</Typography>
          <Typography className={styles.fromToTitle}>
            {`${item?.row?.rentPerYearFrom} - ${item?.row?.rentPerYearTo}`}
          </Typography>
        </Box>
      );
    },
  },
];
